import RouteParamsBuilder from '@/library/route/route-params-builder';

export class CurrentRoute {
    private routeParamsBuilder: RouteParamsBuilder;

    constructor() {
        this.routeParamsBuilder = new RouteParamsBuilder(window.location.pathname + window.location.search);
    }

    public param(id: string, defaultValue: string | null = null): string | null {
        return this.routeParamsBuilder.param(id, defaultValue);
    }

    public setParam(id: string, value: string): void {
        this.routeParamsBuilder.set(id, value);
        this.updateAddressBarWithParams();
    }

    public removeParam(id: string): void {
        this.routeParamsBuilder.remove(id);
        this.updateAddressBarWithParams();
    }

    public paramExists(id: string): boolean {
        return this.routeParamsBuilder.exists(id);
    }

    private updateAddressBarWithParams(): void {
        window.history.replaceState({}, '', this.routeParamsBuilder.path());
    }
}
